import React from 'react'
import './Footer.css'


const Footer = () => {
  return (
    <>
      <div className='footer'>© 2024 Time To Program, Happy Coding</div>
    </>
  )
};

export default Footer
